// jQuery(".button .wc_nutri_btn").magnificPopup({type:"inline",preloader:!1}),
jQuery((function(){jQuery(".swatch :radio").change((function(){var t=jQuery(this).closest(".swatch").attr("data-option-index");var e=jQuery(this).val();jQuery(this).closest("form").find(".single-option-selector").eq(t).val(e).trigger("change")})),$(document).on("click",".addtocartbutten",(function(t){t.preventDefault();var e=$(this).attr("href");$("#triggerbtnn").click(),setTimeout((function(){window.location.href=e}),2e3)}))}));

//# sourceMappingURL=/s/files/1/0421/5380/3934/t/18/assets/custom.js.map?v=1611584074
$(document).ready(function(){
  $('.slick-dynamic-collection-list').slick({
    slidesToShow: 3,
    dots:false,
    arrows: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.slick-featured-collection--content').slick({
    slidesToShow: 3,
    dots:false,
    arrows: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

});